(function ($) {
    function emailIsValid (email) {
        let syntaxMail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return syntaxMail.test(email)
    }
    
    function isEllipsisActive(inputSelector) {
        if(document.getElementById('tmpsmp')) {
            document.getElementById('tmpsmp').remove();
        }
    
        var html = document.createElement('span');
        html.id = 'tmpsmp';
        html.innerHTML = inputSelector.value;
    
        var body = document.getElementsByTagName('body')[0];
        body.appendChild(html);
      
        return inputSelector.clientWidth - 24 - 16 < document.getElementById('tmpsmp').offsetWidth;
    }
    
    function handleEmailInput() {
        let inputFirstNameFooter = document.querySelector('.form-quarterly__input #firstName');
        let inputLastNameFooter = document.querySelector('.form-quarterly__input #lastName');
        let inputMailForm = document.querySelector('.form-quarterly__input #emailNewsletter');
        let inputMailFormContainer = document.querySelector('.form-quarterly__input.input-mail');
        let buttonSign = document.querySelector('.form-quarterly__button');
        let quarterlyMessage = document.querySelector('.quarterly__message .message');
        let firstNameMessage = document.querySelector('.quarterly__firstname .message');
        let lastNameMessage = document.querySelector('.quarterly__lastname .message');
        let signPress = 0;

        // document.getElementById('emailNewsletter').addEventListener('keydown', function(e) {
        //     if(isEllipsisActive(this) && e.target.selectionStart < 2) {
        //         inputMailFormContainer.classList.remove('eclips-text');
        //     }
        //     else if (isEllipsisActive(this)) {             
        //         inputMailFormContainer.classList.add('eclips-text');
        //     }
        // })

        // if(inputMailForm){
        //     inputMailForm.addEventListener('input', function(event) {
        //         buttonSign.classList.toggle('active', this.value.trim() != '');
        //         inputMailFormContainer.classList.toggle('eclips-text', isEllipsisActive(this));

        //         if(!emailIsValid(this.value) && signPress>0 && quarterlyMessage){
        //             quarterlyMessage.classList.remove('opacity-0');
        //             quarterlyMessage.innerHTML = "Please enter a valid email address";
        //             signPress++;
        //         } else if(quarterlyMessage){
        //             quarterlyMessage.classList.add('opacity-0');
        //             quarterlyMessage.innerHTML = "";
        //         }
        //     });
        // }
        if(buttonSign){
            buttonSign.onclick = () =>{
                let error = false;
                if(inputMailForm.value == '') {
                    quarterlyMessage.classList.remove('opacity-0');
                    quarterlyMessage.classList.add('mt-2');
                    quarterlyMessage.style.color = '#F76041';
                    quarterlyMessage.innerHTML = "Please fill in your email address";
                    error = true;
                }
                else if(!emailIsValid(inputMailForm.value)){
                    quarterlyMessage.classList.remove('opacity-0');
                    quarterlyMessage.classList.add('mt-2');
                    quarterlyMessage.style.color = '#F76041';
                    quarterlyMessage.innerHTML = "Please fill in a valid email address";
                    signPress++;
                    error = true;
                }
                else {
                    quarterlyMessage.classList.add('opacity-0');
                    quarterlyMessage.classList.remove('mt-2');
                    quarterlyMessage.innerHTML = "";
                }

                if(inputFirstNameFooter.value == '') {
                    firstNameMessage.classList.remove('opacity-0');
                    firstNameMessage.classList.add('mt-2');
                    firstNameMessage.style.color = '#F76041';
                    firstNameMessage.innerHTML = "Please fill in your first name";
                    error = true;
                }
                else {
                    firstNameMessage.classList.add('opacity-0');
                    firstNameMessage.classList.remove('mt-2');
                    firstNameMessage.innerHTML = "";
                }

                if(inputLastNameFooter.value == '') {
                    lastNameMessage.classList.remove('opacity-0');
                    lastNameMessage.classList.add('mt-2');
                    lastNameMessage.style.color = '#F76041';
                    lastNameMessage.innerHTML = "Please fill in your last name";
                    error = true;
                }
                else {
                    lastNameMessage.classList.add('opacity-0');
                    lastNameMessage.classList.remove('mt-2');
                    lastNameMessage.innerHTML = "";
                }

                if(!error){
                    quarterlyMessage.classList.add('opacity-0');
                    quarterlyMessage.classList.add('mt-2');
                    signPress=0;
                    onSubmit(inputMailForm.value, inputFirstNameFooter.value, inputLastNameFooter.value, function(message, isError) {
                        if(!isError) {
                            inputLastNameFooter.value = '';
                            inputMailForm.value = '';
                            inputFirstNameFooter.value = '';
                            quarterlyMessage.style.color = '#031F51';
                            quarterlyMessage.classList.add('mt-2');

                        }
                        else {
                            firstNameMessage.style.color = '#F76041';
                            lastNameMessage.style.color = '#F76041';
                            quarterlyMessage.style.color = '#F76041';
                        }
                        quarterlyMessage.innerHTML = message;
                        quarterlyMessage.classList.remove('opacity-0');
                    });
                }
            }
        }
    }

    function onSubmit(email, firstName, lastName, callback = null){
        let jsonBody = {
            "fields": [
              {
                "name": "email",
                "value": email
              },
              {
                "name": "firstname",
                "value": firstName
              },
              {
                "name": "lastname",
                "value": lastName
              }
            ],
            "legalConsentOptions":{
                "consent":{
                    "consentToProcess":true,
                        "text":"Agree to newsletter subscription",
                    "communications":[
                    {
                        "value":true,
                        "subscriptionTypeId":11832735,
                        "text":"Consent to communicate through newsletter subscription type ID 11832735"
                    }
                    ]
                }
            }
          };
          
        let url = 'https://api.hsforms.com/submissions/v3/integration/submit/8357376/98afb1a1-2678-4f22-b664-7723de5799ea';
        return fetch( url,
                {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                    body: JSON.stringify(jsonBody),
                }
            )
            .then((response) => {
                return response.json();
            })
            .then(data => {
                let message = '';
                let isError = false;
                if(data.status && data.status == 'error' && data.errors[0].errorType == 'INVALID_EMAIL') {
                    message = "Please enter a valid email address";
                    isError = true;
                }

                if(data.inlineMessage) {
                    message = "Thank you for subscribing";
                }
                callback && callback(message, isError);
            })
            .catch(function(error) {
                console.log('There has been a problem with your fetch operation: ' + error.message);
            });
    }

    $(document).on('ready', () =>{
        handleEmailInput();
    })
})(jQuery);